import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { get_single_user } from '../../../../UserManagement/users/api/usersApi';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';

// Define the context type
interface UserContextType {
  currentUserId: string | null;
  setCurrentUserId: (id: string | null) => void;
  employeeName: string | null; // Assuming employeeName is a string
  setEmployeeName: React.Dispatch<React.SetStateAction<string | null>>; // Use React.Dispatch for setState
}
// Create the context with a default value
const UserContext = createContext<UserContextType | undefined>(undefined);

// Create a custom hook for easier usage of the context
export const useUserContext = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUserContext must be used within a UserProvider');
  }
  return context;
};

// Create the provider component
export const UserProvider: React.FC<any> = ({ children }) => {
  const [currentUserId, setCurrentUserId] = useState<string | null>(null);
  const [employeeName, setEmployeeName] = useState<any>("");
  const { data: viewPersonalDetails, isLoading: viewIsLoading, error: viewIsError } = useQuery(
    ['ViewPersonalDetails', currentUserId,{ refetchOnWindowFocus: false }],
    () => get_single_user(currentUserId),
    { enabled: !!currentUserId }
  );
  useEffect(() => {
    if (viewPersonalDetails) {
      if (viewPersonalDetails.status === true && viewPersonalDetails.message === "You cannot view super admin.") {
        toast.error(viewPersonalDetails.message);
      } else {
        setEmployeeName(viewPersonalDetails?.data?.[0]?.full_name);
        localStorage.setItem("Employee_Name", viewPersonalDetails?.data?.[0]?.full_name);
      }
    }
  }, [viewPersonalDetails]);
  useEffect(() => {
    const userId = localStorage.getItem('current_user_id');
    setCurrentUserId(userId);
  }, []);

  return (
    <UserContext.Provider value={{ currentUserId, setCurrentUserId, employeeName, setEmployeeName }}>
      {children}
    </UserContext.Provider>
  );
};
